import { Auth } from "aws-amplify";
import { startSubmit, stopSubmit } from "redux-form";
import { call, put } from "redux-saga/effects";

import { MiniMessageBox } from "../../../../MiniMessageBox";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* authnzCognitoConfirmation(arg0: { email: string; confirmation_code: string }): Generator<any, any, any> {
  const { email, confirmation_code } = arg0;
  return yield Auth.confirmSignUp(email, confirmation_code);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* authnzConfirmRegistrationWorker(action: any): Generator<any, any, any> {
  const form = "ConfirmationForm";

  const { payload, navigate } = action;

  try {
    yield put(startSubmit(form));

    yield call(authnzCognitoConfirmation, payload.data);
    yield put(stopSubmit(form));
    navigate("/");
  } catch (error) {
    yield put(stopSubmit(form));

    if (error instanceof Error) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: error.message }));
    } else if (typeof error === "object" && error !== null && "message" in error) {
      yield put(MiniMessageBox.showMiniBoxMessage({ show: true, type: "error", message: String((error as { message: unknown }).message) }));
    }
  }
}
